// tslint:disable

/** Are we currently running in a development environment. */
const IS_DEV = process.env.NODE_ENV === "development";

/** Dev escape hatch for overriding the base URL. */
const BASE_URL = (window as any).__BASE_URL__ || "";

// todo(b/129357862): Deprecate this after .NET core go-live.
/** The legacy header name used for sending the CSRF form token. */
const LEGACY_XSRF_HEADER_TOKEN_NAME = "__RequestVerificationToken";
// todo(b/129357862): Make this only load from Webpack DefinePlugin.
// todo(b/129357862): Change names for this to "X-XSRF-TOKEN" back end.
/** The header name used for sending the CSRF form token. */
const XSRF_HEADER_TOKEN_NAME =
  (window as any).__XSRF_HEADER_TOKEN_NAME__ || "X-XSRF-TOKEN";

/** The JS readable XSRF-TOKEN that should be sent as X-XSRF-TOKEN header. */
const XSRF_TOKEN_COOKIE_NAME = "XSRF-TOKEN";

import * as fetch from "isomorphic-fetch";
import * as Cookies from "js-cookie";
import { BucketRateLimiter } from "./rateLimiting/BucketRateLimiter";
import { featureFlags } from "./featureFlags";

let rateLimiter: BucketRateLimiter | null = null;
const rateLimitQps = parseInt(featureFlags.clientRpcRateLimit ?? "", 10);
if (!isNaN(rateLimitQps) && rateLimitQps > 0) {
  rateLimiter = new BucketRateLimiter(rateLimitQps);
}

const google = {
  rpc: {
    Code: {
      // Not an error; returned on success
      //
      // HTTP Mapping: 200 OK
      OK: "ok", // = 0;
      // The operation was cancelled, typically by the caller.
      //
      // HTTP Mapping: 499 Client Closed Request
      CANCELLED: "cancelled", // = 1;
      // Unknown error.  For example, this error may be returned when
      // a `Status` value received from another address space belongs to
      // an error space that is not known in this address space.  Also
      // errors raised by APIs that do not return enough error information
      // may be converted to this error.
      //
      // HTTP Mapping: 500 Internal Server Error
      UNKNOWN: "unknown", // = 2;
      // The client specified an invalid argument.  Note that this differs
      // from `FAILED_PRECONDITION`.  `INVALID_ARGUMENT` indicates arguments
      // that are problematic regardless of the state of the system
      // (e.g., a malformed file name).
      //
      // HTTP Mapping: 400 Bad Request
      INVALID_ARGUMENT: "invalidArgument", // = 3;
      // The deadline expired before the operation could complete. For operations
      // that change the state of the system, this error may be returned
      // even if the operation has completed successfully.  For example, a
      // successful response from a server could have been delayed long
      // enough for the deadline to expire.
      //
      // HTTP Mapping: 504 Gateway Timeout
      DEADLINE_EXCEEDED: "deadlineExceeded", // = 4;
      // Some requested entity (e.g., file or directory) was not found.
      //
      // Note to server developers: if a request is denied for an entire class
      // of users, such as gradual feature rollout or undocumented allowlist,
      // `NOT_FOUND` may be used. If a request is denied for some users within
      // a class of users, such as user-based access control, `PERMISSION_DENIED`
      // must be used.
      //
      // HTTP Mapping: 404 Not Found
      NOT_FOUND: "notFound", // = 5;
      // The entity that a client attempted to create (e.g., file or directory)
      // already exists.
      //
      // HTTP Mapping: 409 Conflict
      ALREADY_EXISTS: "alreadyExists", // = 6;
      // The caller does not have permission to execute the specified
      // operation. `PERMISSION_DENIED` must not be used for rejections
      // caused by exhausting some resource (use `RESOURCE_EXHAUSTED`
      // instead for those errors). `PERMISSION_DENIED` must not be
      // used if the caller can not be identified (use `UNAUTHENTICATED`
      // instead for those errors). This error code does not imply the
      // request is valid or the requested entity exists or satisfies
      // other pre-conditions.
      //
      // HTTP Mapping: 403 Forbidden
      PERMISSION_DENIED: "permissionDenied", // = 7;
      // The request does not have valid authentication credentials for the
      // operation.
      //
      // HTTP Mapping: 401 Unauthorized
      UNAUTHENTICATED: "unauthenticated", // = 16;
      // Some resource has been exhausted, perhaps a per-user quota, or
      // perhaps the entire file system is out of space.
      //
      // HTTP Mapping: 429 Too Many Requests
      RESOURCE_EXHAUSTED: "resourceExhausted", // = 8;
      // The operation was rejected because the system is not in a state
      // required for the operation's execution.  For example, the directory
      // to be deleted is non-empty, an rmdir operation is applied to
      // a non-directory, etc.
      //
      // Service implementors can use the following guidelines to decide
      // between `FAILED_PRECONDITION`, `ABORTED`, and `UNAVAILABLE`:
      //  (a) Use `UNAVAILABLE` if the client can retry just the failing call.
      //  (b) Use `ABORTED` if the client should retry at a higher level
      //      (e.g., when a client-specified test-and-set fails, indicating the
      //      client should restart a read-modify-write sequence).
      //  (c) Use `FAILED_PRECONDITION` if the client should not retry until
      //      the system state has been explicitly fixed.  E.g., if an "rmdir"
      //      fails because the directory is non-empty, `FAILED_PRECONDITION`
      //      should be returned since the client should not retry unless
      //      the files are deleted from the directory.
      //
      // HTTP Mapping: 400 Bad Request
      FAILED_PRECONDITION: "failedPrecondition", // = 9;
      // The operation was aborted, typically due to a concurrency issue such as
      // a sequencer check failure or transaction abort.
      //
      // See the guidelines above for deciding between `FAILED_PRECONDITION`,
      // `ABORTED`, and `UNAVAILABLE`.
      //
      // HTTP Mapping: 409 Conflict
      ABORTED: "aborted", // = 10;
      // The operation was attempted past the valid range.  E.g., seeking or
      // reading past end-of-file.
      //
      // Unlike `INVALID_ARGUMENT`, this error indicates a problem that may
      // be fixed if the system state changes. For example, a 32-bit file
      // system will generate `INVALID_ARGUMENT` if asked to read at an
      // offset that is not in the range [0,2^32-1], but it will generate
      // `OUT_OF_RANGE` if asked to read from an offset past the current
      // file size.
      //
      // There is a fair bit of overlap between `FAILED_PRECONDITION` and
      // `OUT_OF_RANGE`.  We recommend using `OUT_OF_RANGE` (the more specific
      // error) when it applies so that callers who are iterating through
      // a space can easily look for an `OUT_OF_RANGE` error to detect when
      // they are done.
      //
      // HTTP Mapping: 400 Bad Request
      OUT_OF_RANGE: "outOfRange", // = 11;
      // The operation is not implemented or is not supported/enabled in this
      // service.
      //
      // HTTP Mapping: 501 Not Implemented
      UNIMPLEMENTED: "unimplemented", // = 12;
      // Internal errors.  This means that some invariants expected by the
      // underlying system have been broken.  This error code is reserved
      // for serious errors.
      //
      // HTTP Mapping: 500 Internal Server Error
      INTERNAL: "internal", // = 13;
      // The service is currently unavailable.  This is most likely a
      // transient condition, which can be corrected by retrying with
      // a backoff.
      //
      // See the guidelines above for deciding between `FAILED_PRECONDITION`,
      // `ABORTED`, and `UNAVAILABLE`.
      //
      // HTTP Mapping: 503 Service Unavailable
      UNAVAILABLE: "unavailable", // = 14;
      // Unrecoverable data loss or corruption.
      //
      // HTTP Mapping: 500 Internal Server Error
      DATA_LOSS: "dataLoss", // = 15;
    },
  },
};
/** End error section. */

declare let MiniProfiler: any;

type ResultConstraint = (ArrayBuffer | Blob | any | string | null) &
  GeneralResponse<any>;

type RequestAction<TBody, TResult extends ResultConstraint> = (
  body: TBody
) => Promise<TResult>;

export function getAntiForgeryToken(): string {
  const antiForgeryToken = Cookies.get(XSRF_TOKEN_COOKIE_NAME);
  if (!antiForgeryToken) {
    throw new Error("An anti-forgery token could not be found.");
  }
  return antiForgeryToken;
}

const createBody = <TBody>(bodyParams: TBody | string | Blob): string => {
  // note that this function assumes a content-type = 'application/json'
  const bodyParamsType = typeof bodyParams;
  if (bodyParamsType === "string") {
    return JSON.stringify(bodyParams);
  }
  if (bodyParamsType === "number") {
    return `"${bodyParams}"`;
  } else {
    return typeof bodyParams === "object"
      ? JSON.stringify(bodyParams)
      : JSON.stringify({});
  }
};

const processMiniProfilerHeaders = (response: Response) => {
  const miniprofilerHeaders = response.headers.get("X-MiniProfiler-Ids");
  if (typeof MiniProfiler !== "undefined" && miniprofilerHeaders?.length) {
    try {
      MiniProfiler.fetchResults(JSON.parse(miniprofilerHeaders));
    } catch (e) {
      console.error(
        "Failed to parse mini-profiler header",
        miniprofilerHeaders
      );
    }
  }
};

const fetchWorker = async <TBody, TResult extends ResultConstraint>(
  route: string,
  requestBody?: TBody
): Promise<TResult> => {
  const url = `${BASE_URL}/requests/${route}`;
  const antiForgeryToken = getAntiForgeryToken();
  const headers: Headers = new Headers();
  headers.set(LEGACY_XSRF_HEADER_TOKEN_NAME, antiForgeryToken);
  headers.set(XSRF_HEADER_TOKEN_NAME, antiForgeryToken);
  headers.set("Content-Type", "application/json");
  headers.set("Accept", "application/json");
  const credentials: RequestCredentials = IS_DEV ? "include" : "same-origin";
  const body = requestBody ? createBody(requestBody) : undefined;

  // Throw an error if the rate limit for this RPC is exceeded.
  if (rateLimiter !== null && !rateLimiter.canCall(route)) {
    throw new CanonicalError(
      `The RPC ${route} was rate-limited.`,
      CanonicalErrorCode.RESOURCE_EXHAUSTED
    );
  }

  // if this throws, then it was an actual network error: the server
  // never returned at all.
  let response: Response;
  try {
    response = await fetch(url, {
      headers,
      credentials,
      body,
      method: "POST",
    });
  } catch (e) {
    console.error("Fetch error:", e);
    throw e;
  }
  processMiniProfilerHeaders(response);
  // if we don't have a 2xx status code, then we should probably be handling that before
  // we try to parse some JSON. Not Implemented because it would be a change in behavior
  // from what we currently have. Therefore to

  // if this throws, it means there wasn't JSON
  let generalResponse: GeneralResponse<TResult>;
  try {
    generalResponse = await response.json();
  } catch (e) {
    throw new Error(`Command handler response not valid JSON`);
  }

  if (generalResponse.wasSuccessful) {
    return generalResponse.result;
  } else if (generalResponse.wasSuccessful === false) {
    const errors = generalResponse.errors;
    const errorCode =
      generalResponse?.error?.code ?? CanonicalErrorCode.INTERNAL;
    const errorMessage =
      (generalResponse.error && generalResponse.error.message) ||
      errors[0] ||
      (errorCode === CanonicalErrorCode.OK ? "" : "Internal");

    const errorDetails = generalResponse.error && generalResponse.error.details;
    throw new CanonicalError(errorMessage, errorCode, errorDetails);
  }
  throw new Error(
    `Command handler response had unexpected shape: ${JSON.stringify(
      Object.keys(generalResponse as any)
    )}`
  );
};

/**
 * Creates a strongly typed fetch function for requests.
 * @param opts options to use on the request.
 */
export function createRequestClient<TBody, TResult extends ResultConstraint>(
  route: string
): RequestAction<TBody, TResult> {
  return (req: TBody) => fetchWorker(route, req);
}

// Hardcoding these since they don't change and we transpile the values as camelCase strings for historical reasons
// but still need the enum number in some spots.
export enum CanonicalErrorCode {
  OK = 0,
  CANCELLED = 1,
  UNKNOWN = 2,
  INVALID_ARGUMENT = 3,
  DEADLINE_EXCEEDED = 4,
  NOT_FOUND = 5,
  ALREADY_EXISTS = 6,
  PERMISSION_DENIED = 7,
  RESOURCE_EXHAUSTED = 8,
  FAILED_PRECONDITION = 9,
  ABORTED = 10,
  OUT_OF_RANGE = 11,
  UNIMPLEMENTED = 12,
  INTERNAL = 13,
  UNAVAILABLE = 14,
  DATA_LOSS = 15,
  UNAUTHENTICATED = 16,
}

function getCanonicalErrorFromCode(code: number): string {
  switch (code) {
    case CanonicalErrorCode.OK:
      return google.rpc.Code.OK;
    case CanonicalErrorCode.CANCELLED:
      return google.rpc.Code.CANCELLED;
    case CanonicalErrorCode.UNKNOWN:
      return google.rpc.Code.UNKNOWN;
    case CanonicalErrorCode.INVALID_ARGUMENT:
      return google.rpc.Code.INVALID_ARGUMENT;
    case CanonicalErrorCode.DEADLINE_EXCEEDED:
      return google.rpc.Code.DEADLINE_EXCEEDED;
    case CanonicalErrorCode.NOT_FOUND:
      return google.rpc.Code.NOT_FOUND;
    case CanonicalErrorCode.ALREADY_EXISTS:
      return google.rpc.Code.ALREADY_EXISTS;
    case CanonicalErrorCode.PERMISSION_DENIED:
      return google.rpc.Code.PERMISSION_DENIED;
    case CanonicalErrorCode.RESOURCE_EXHAUSTED:
      return google.rpc.Code.RESOURCE_EXHAUSTED;
    case CanonicalErrorCode.FAILED_PRECONDITION:
      return google.rpc.Code.FAILED_PRECONDITION;
    case CanonicalErrorCode.ABORTED:
      return google.rpc.Code.ABORTED;
    case CanonicalErrorCode.OUT_OF_RANGE:
      return google.rpc.Code.OUT_OF_RANGE;
    case CanonicalErrorCode.UNIMPLEMENTED:
      return google.rpc.Code.UNIMPLEMENTED;
    case CanonicalErrorCode.INTERNAL:
      return google.rpc.Code.INTERNAL;
    case CanonicalErrorCode.UNAVAILABLE:
      return google.rpc.Code.UNAVAILABLE;
    case CanonicalErrorCode.DATA_LOSS:
      return google.rpc.Code.DATA_LOSS;
    case CanonicalErrorCode.UNAUTHENTICATED:
      return google.rpc.Code.UNAUTHENTICATED;
    default:
      return google.rpc.Code.INTERNAL;
  }
}

export class CanonicalError extends Error {
  readonly code: CanonicalErrorCode;
  readonly status: string;
  readonly details: any[] | null | undefined;

  constructor(
    message: string,
    code: number,
    details: any[] | null | undefined = undefined
  ) {
    super(message);
    /*
      A breaking change in TypeScript occured that means extending 
      from certain classes (like Error) no longer works with certain
      compiler outputs. In some cases this code will run, but the
      returned object will be an Error instead of a CanoicalError.

      If we manually set the prototype, then the methods will at
      least still be available everywhere, though `instanceof` 
      won't work correctly, so duck-typing will be necessary if
      you want to check the type
     */
    Object.setPrototypeOf(this, CanonicalError.prototype);
    this.code = code;
    this.status = getCanonicalErrorFromCode(code);
    this.details = details;
  }

  getErrorInfo(): ErrorInfo | undefined {
    if (!this.details) {
      return undefined;
    }

    for (const errorDetail of this.details) {
      if (!errorDetail) {
        continue;
      }

      if (
        errorDetail &&
        "@type" in errorDetail &&
        errorDetail["@type"] === "type.googleapis.com/google.rpc.ErrorInfo"
      ) {
        return new ErrorInfo(
          errorDetail.reason || "",
          errorDetail.domain || "",
          errorDetail.metadata || {}
        );
      }
    }

    return undefined;
  }
}
class ErrorInfo {
  readonly reason: string;
  readonly domain: string;
  readonly metadata: { [key: string]: string };

  constructor(
    reason: string,
    domain: string,
    metadata: { [key: string]: string }
  ) {
    this.reason = reason;
    this.domain = domain;
    this.metadata = metadata;
  }
}

interface ErrorResponse {
  wasSuccessful: false;
  errors: string[];
  // todo(b/140209162): remove Partial when mediatorController is passing all info
  error?: Partial<{
    // This corresponds to `google.rpc.Status.code`.
    code: number;
    // This corresponds to `google.rpc.Status.message`.
    message: string;
    // This is the enum version for `google.rpc.Status.code`.
    status: string;
    // This corresponds to `google.rpc.Status.details`.
    details: {
      typeUrl: string;
      value: any;
    }[];
  }>;
}
interface SuccessResponse<TResponse> {
  wasSuccessful: true;
  result: TResponse;
}

type GeneralResponse<TResponse> = SuccessResponse<TResponse> | ErrorResponse;
